import { render, staticRenderFns } from "./YangBen.vue?vue&type=template&id=eb03c1bc&scoped=true&"
import script from "./YangBen.vue?vue&type=script&lang=js&"
export * from "./YangBen.vue?vue&type=script&lang=js&"
import style0 from "./YangBen.vue?vue&type=style&index=0&id=eb03c1bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb03c1bc",
  null
  
)

export default component.exports